import store from '../store'

export default async function ({ next }) {
  if(!store.getters['serverTime/getTime'] ) {
    await store.dispatch('serverTime/loadServerTime')
  }
  next()
}
